import { render, staticRenderFns } from "./ContenidoModal.vue?vue&type=template&id=15cf259e&"
import script from "./ContenidoModal.vue?vue&type=script&lang=ts&"
export * from "./ContenidoModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('15cf259e', component.options)
    } else {
      api.reload('15cf259e', component.options)
    }
    module.hot.accept("./ContenidoModal.vue?vue&type=template&id=15cf259e&", function () {
      api.rerender('15cf259e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/ContenidoModal.vue"
export default component.exports